// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './assets/css/main.scss'
//
import Vue from 'vue'
import App from './App'
import router from './router'
//firebase
import firebase from 'firebase/app'
import 'firebase/auth';
import {config} from './firebase/config'
//store
import {store} from './store'
//
//Vueitify
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import './assets/libs/googleFont.css'
//
import VueLazyload from 'vue-lazyload'
// helper
import {defineDbRefs} from '@/helper/dbRefs'
import {loadProgressBar} from 'axios-progress-bar'
//modal
import VModal from 'vue-js-modal'

// optionally use a fetch polyfill
import 'whatwg-fetch'

import VueFetch from 'vue-fetch'
Vue.use(VueFetch, {
  polyfill: true   //should vue-fetch load promise polyfill, set to false to use customer polyfill
});
import VueMeta from 'vue-meta'
//lazy image loader
import {VLazyImagePlugin} from "v-lazy-image";
//
import VueYouTubeEmbed from 'vue-youtube-embed';
//
import vuescroll from 'vuescroll';

import { format } from "date-fns";
import addDays from 'date-fns/addDays'

Vue.use(vuescroll, {
  ops: {
    bar: {
      background: "#bd10e0",
      gutterOfSide: "2px"
    }
  },
});
;

// vue modal
Vue.use(VModal)

//
Vue.use(Vuetify)
Vue.use(VueLazyload)
Vue.use(VLazyImagePlugin);
Vue.use(VueMeta,{
  refreshOnceOnNavigation: true
})
Vue.use(VueYouTubeEmbed)
//
Vue.config.productionTip = false

let firebaseApp = firebase.initializeApp(config)
defineDbRefs() // db refs.
store.state.gen.appName = 'Viewzzz'

import axios from 'axios'

let _pass
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App},
  render: h => h(App),
  store,
  created() {
    loadProgressBar()
  }
})

async function get_token() {
  return new Promise(async (resolve) => {
    let currentUser = await firebase.auth().currentUser
    if (currentUser) {
      let token = await currentUser.getIdToken(true)
      //return token
      resolve(token)
    }
    else {
      resolve('')
      //return ''
    }
  })
}

let curDate = new Date();
let curFullYear = curDate.getFullYear();
let curMonth = curDate.getMonth() + 1;
let curDay = curDate.getDate();
if (curDay < 10) {
  curDay = "0" + curDay;
}
if (curMonth < 10) {
  curMonth = "0" + curMonth;
}
var currentDate = curFullYear + "-" + curMonth + "-" + curDay;
let filterObject = {
  currentDate: format(new Date(), 'yyyy-MM-dd'),
  checkinDate: format(new Date(), 'yyyy-MM-dd'),
  checkoutDate: format(addDays(new Date(),1), 'yyyy-MM-dd'),
  nosOfGuests: 1,
  filtered: false,
  st: ['all'],
  loc: 'worldwide',
  tab: 'all'
};
localStorage.setItem("filterSettings", JSON.stringify(filterObject));

// req 1 // start loader.
axios.interceptors.request.use(
  async (config) => {
    let token = await get_token()
    if (!config.url.includes('https://maps.googleapis.com')) {
      config.headers['authorization'] = `Bearer ${token}`
    }

    // LOADER
    if (!config.url.includes('markExposure') &&
      !config.url.includes('operationOnPhoto') &&
      !config.url.includes('getTagSuggestion_uploadImage') &&
      !config.url.includes('maps.googleapis.com') &&
      !config.url.includes('nearby_photo') &&
      !config.url.includes('getParticularPhotoDetails_2') &&
      !config.url.includes('imgDet_top')
    )
      store.state.gen.showLoader = true
    return config
  }
)


// req 1 // stop loader.
axios.interceptors.response.use(
  (config) => {
    store.state.gen.showLoader = false
    return config
  }
)



// WEBPACK FOOTER //
// ./src/main.js